// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"327":"76a8b3f9","995":"b59b637f"}[chunkId] + ".css";
};